import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './organisms/Shop.js';
import Sections from './organisms/Sections.js';
import Toast from './atoms/Toast/index.js';
import PopinNewsletter from './molecules/PopinNewsletter.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      Toast,
      PopinNewsletter,
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}

export default createApp(App, document.documentElement);
